import type { Chart, Plugin } from "chart.js";

import { parseDate } from "@/utils/formatters";

/** Draws a dashed vertical "Today" divider. Configure via
 *  options.plugins.todayLine = { value: "<ISO date>", label }. */
export const todayLinePlugin: Plugin = {
  id: "todayLine",
  afterDatasetsDraw(
    chart: Chart,
    _args,
    opts: { value?: string; label: string },
  ) {
    if (!opts.value) return;
    const x = chart.scales.x.getPixelForValue(parseDate(opts.value).getTime());
    const { top, bottom } = chart.chartArea;
    const { ctx } = chart;
    ctx.save();
    ctx.beginPath();
    ctx.setLineDash([4, 4]);
    ctx.lineWidth = 1;
    ctx.strokeStyle = "#a1a1aa";
    ctx.moveTo(x, top);
    ctx.lineTo(x, bottom);
    ctx.stroke();
    ctx.setLineDash([]);
    ctx.fillStyle = "#71717a";
    ctx.font = "11px Inter, sans-serif";
    ctx.textAlign = "center";
    ctx.fillText(opts.label, x, top - 4);
    ctx.restore();
  },
};
